export const HH_INTEGRATION_PATH = "/settings-menu/hh-integration";
